import MemberListDesktop from './member-list-desktop';
import MemberListMobile from './member-list-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(MemberListMobile, MemberListDesktop);



// WEBPACK FOOTER //
// ./app/components/member-list/member-list.js